export default __webpack_public_path__ + "public/fonts/upload-icon.svg";